import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { PRESENCE_OUTPUT } from './topics';
import type { PresenceStatus } from './presence';
import { presenceStatusSchema } from './presence';
import type { PresenceSource } from './entry';
import { presenceSourceSchema } from './entry';

export const UPDATE = 'PRESENCE/UPDATE' as const;

export interface IUpdateAction {
  type: typeof UPDATE;
  payload: {
    uid: string;
    source: PresenceSource;
    picture?: string;
    displayName: string;
    checkedIn: boolean;
    status: PresenceStatus;
    lastTimestamp: number;
    sessionId: string;
    activationTimestamp: number;
  };
}

export const updateActionSchema = objectSchemaOf<IUpdateAction>({
  type: Joi.string().valid(UPDATE).required(),
  payload: objectSchemaOf<IUpdateAction['payload']>({
    uid: Joi.string().required(),
    source: presenceSourceSchema.required(),
    picture: Joi.string().optional(),
    displayName: Joi.string().required(),
    checkedIn: Joi.boolean().required(),
    status: presenceStatusSchema.required(),
    lastTimestamp: Joi.number().required(),
    sessionId: Joi.string().required(),
    activationTimestamp: Joi.number().required(),
  }),
});

export const update = actionCreator({
  schema: updateActionSchema,
  topic: PRESENCE_OUTPUT,
  type: UPDATE,
});
